/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { IGeoLocation, IRequestContext } from '@msdyn365-commerce/core';
import axios from 'axios';
/**
 * A basic implementation of the ExperimentationProvider interface used for testing
 */
class MsDyn365GeoLookupTestConnector {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    private geoEndpoint: string = '';
    public initialize(config: any): Promise<boolean> {
        console.log(`MsDyn365 geoLookup Test Connector called with config: ${JSON.stringify(config)}`);
        this.geoEndpoint = config.geoEndpoint;
        return Promise.resolve(true);
    }

    public async getGeoInformation(ip: string, requestContext: IRequestContext, userId?: string): Promise<IGeoLocation | undefined> {
        let geoInformation: IGeoLocation | undefined;
        let geoMockService;
        if (!this.geoEndpoint) {
            return geoInformation;
        }
        const result = (await axios.get(this.geoEndpoint)).data;
        if (result) {
            for (const service of result.service) {
                if (service.name === 'MockGeo') {
                    geoMockService = <any[]>service.mock;
                }
            }
        }

        if (geoMockService) {
            for (const mock of geoMockService) {
                if (mock.input?.ip === ip) {
                    geoInformation = {};
                    geoInformation.city = mock.response?.city;
                    geoInformation.country = mock.response?.country;
                    geoInformation.region = mock.response?.region;
                    geoInformation.postalCode = mock.response && mock.response['postal code'];
                }
            }
        }

        return Promise.resolve(geoInformation);
    }
}

const connector = new MsDyn365GeoLookupTestConnector();
export default connector;
